import styled from 'styled-components';
import { Button } from '@bynder/design-system';

export const OutlineButton = styled(Button)`
    max-width: 44px;
`;

export const SwitchRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    margin-top: 8px;
`;
